import { render } from "./Activos.vue?vue&type=template&id=2ec04880"
import script from "./Activos.vue?vue&type=script&lang=js"
export * from "./Activos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__